window.$ = window.jQuery = require("jquery");

import Swiper, { Navigation, Autoplay, Pagination } from "swiper";
import "swiper/css/bundle";
import "jquery-validation";
import "jquery-validation/dist/additional-methods";

window.Swiper = Swiper;
window.Autoplay = Autoplay;
window.Navigation = Navigation;
window.Pagination = Pagination;

window.Swal = require("sweetalert2");

require("./web_function");
require("./dialogs/confirm_dialog");
require("./dialogs/loading_dialog");
require("./validation/validation_helper");
require("./validation/additional-methods");
